<div class="container-fluid mt-4">
  <h4 class="mb-3">
    <i class="fi fi-rr-drop-down"></i> მენიუ 

    <span *ngIf="currentLang == 'en'">(EN)</span>
  </h4>
  <div class="row">
    <div class="col-md-3">
      <select [(ngModel)]="selectedMenu" class="form-select mb-3 " (change)="onMenuChange()" >
        <option value="top">ზედა მენიუ</option>
        <option value="bottom">ქვედა მენიუ</option>
      </select>
    </div>
    <div class="col-md-3">
     <button (click)="save()" class="btn btn-primary"  [disabled]="loadSave" *ngIf="isDrangDrop">
        <span *ngIf="loadSave" class="spinner-border spinner-border-sm" role="status" ></span>
        სტრუქტურის შენახვა
      </button>
    </div>
  </div>
 

  <app-spinner [loading]="load" text="იტვირთება..."></app-spinner>

  <app-error  *ngIf="!load && error" [title]="'შეცდომა ჩატვირთვის დროს'" (reload)="getMenu()"></app-error>
  
  <div *ngIf="!load">

    <div
      cdkDropList
      [cdkDropListData]="menuItems"
      (cdkDropListDropped)="drop($event)"
      cdkDropListOrientation="vertical"
    >
      <div *ngFor="let item of menuItems; trackBy: trackById" class="menu-drag-container" cdkDrag>
        <div cdkDragHandle class="drag-handle"><i class="fi fi-rr-arrows"></i></div>
        <app-menu-item
          [item]="item"
          (update)="onUpdate()"
        ></app-menu-item>
        <ng-template cdkDragPlaceholder>
          <div class="menu-drag-container drag-placeholder"></div>
        </ng-template>
      </div>
    </div>

    
  </div>

</div>